import { getClient, authHeader } from './session'
import { getLibraryData } from './fetchData'

import { alert } from './stores/alert'
import { loading } from './stores/loading'
import { translate } from './i18n'
import { libTranslate } from './libraryDictionary'

let materials = null;

const getMaterials = async () => {
    const clientId = getClient();
    if (!clientId) {
        return null;
    }

    if (!materials) {
        loading.newLoading();
        try {
            const url = (await getLibraryData('materials')).catalogUrl;
            const response = await fetch(url, {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            });
            if (response.status === 200) {
                const materialsResponse = (await response.json()).root;
                materials = materialsResponse.map(({
                    type, id, name, icon, children, metadata, name_localized
                }) => ({
                    type, id,
                    name: libTranslate(id, name),
                    icon, children, metadata, name_localized
                }));
            }    
        }
        catch (err) {
            alert.newAlert({ message: translate('alerts_error_notLoadMaterials'), type: 'error' });
        }
        finally {
            loading.removeLoading();
        }
    }
    return materials;
}

export { getMaterials }